/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import {
  DefaultButton,
  FocusTrapZone,
  Layer,
  Overlay,
  Popup,
  PrimaryButton,
  Stack,
  Text,
} from "@fluentui/react";

import {
  deleteButtonStyles,
  popupContentStyles,
  popupHorizontalGapStackTokens,
  popupStyles,
  popupTitleStyles,
} from "./ConfirmationPopup.styles";
import { IConfirmationPopupProps } from "./IConfirmationPopupProps";

const ConfirmationPopup = (props: IConfirmationPopupProps): ReactElement => {
  const {
    title,
    description,
    confirmButtonText,
    cancelButtonText,
    disableActions,
    onConfirm,
    onCancel,
    onDismiss,
  } = props;
  return (
    <Layer>
      <Popup className={popupStyles.root} role="dialog" aria-modal="true" onDismiss={onDismiss}>
        <Overlay onClick={onDismiss} />
        <FocusTrapZone>
          <div role="document" className={popupStyles.content}>
            <Stack tokens={popupHorizontalGapStackTokens}>
              <Stack.Item>
                <Text styles={popupTitleStyles}>{title}</Text>
              </Stack.Item>
              <Stack.Item>
                <Text styles={popupContentStyles}>{description}</Text>
              </Stack.Item>
              <Stack horizontal horizontalAlign="end">
                <DefaultButton
                  onClick={onConfirm}
                  styles={deleteButtonStyles}
                  disabled={disableActions}
                >
                  {!!confirmButtonText ? confirmButtonText : "Confirm"}
                </DefaultButton>
                <PrimaryButton onClick={onCancel} disabled={disableActions}>
                  {!!cancelButtonText ? cancelButtonText : "Cancel"}
                </PrimaryButton>
              </Stack>
            </Stack>
          </div>
        </FocusTrapZone>
      </Popup>
    </Layer>
  );
};

export default ConfirmationPopup;
